import { makeStyles } from "tss-react/mui"
import { Box, Typography } from "@mui/material"
import { LocalizedEnum, LocalizedStrict } from "../../localization/components/AppLocalized"
import { UserType } from "../../login/loginTypes"
import { CardContentBox } from "./CardElements"
import { InfoBox } from "./InfoBox"

const useStyles = makeStyles()((theme) => ({
    wrap: {
        textAlign: "center",
        background: "#CEF8DB",
        color: theme.palette.text.primary,
        borderRadius: "0.5rem",
        padding: "0.5rem",
    },
}))

type UserTypeCardProps = { type: UserType }

export const UserTypeCard = ({ type }: UserTypeCardProps) => {
    const { classes } = useStyles()

    return (
        <CardContentBox
            title={
                <LocalizedStrict id="profile-user-type">
                    <>User Type</>
                </LocalizedStrict>
            }
            listSpacing="1.5rem"
        >
            <Box className={classes.wrap}>
                <LocalizedEnum base="profile-usertype" enumValue={type}>
                    <Typography variant="h5">{type}</Typography>
                </LocalizedEnum>
            </Box>
            <InfoBox
                description={
                    <LocalizedEnum base="profile-user-type-info-mode" enumValue={type}>
                        <>{type}</>
                    </LocalizedEnum>
                }
            />
        </CardContentBox>
    )
}
